import React from "react";
import { Typography } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CheckoutSuccess: React.FC = () => {
  return (
    <React.Fragment>
      <div style={{background: "white", padding: "1rem 4rem", minHeight: "85vh", display: "flex", justifyContent: "center", flexDirection: "column", textAlign: "center", justifyItems: "center"}}>
        <CheckCircleIcon color="success" fontSize="large" sx={{
          textAlign: "center",
          justifySelf: "center",
          fontSize: "10rem",
          alignSelf:  "center"
        }} />
        <Typography variant="h5" gutterBottom>
          Thank you for your order.
        </Typography>
        <Typography variant="subtitle1">
          We have emailed your reservation confirmation. In case you have any questions, please don’t hesitate to contact us.
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default CheckoutSuccess;
